export default function FilterToggle({ id, label, checked, onChange, description }) {
  return (
    <div className="flex h-8 items-center justify-between gap-2 rounded border border-gray-300 bg-white px-2">
      <div className="min-w-0">
        <label htmlFor={`${id}-control`} className="block text-xs font-semibold text-gray-800">
          {label}
        </label>
        {description ? (
          <p className="text-[10px] text-gray-600">{description}</p>
        ) : null}
      </div>
      <button
        id={`${id}-control`}
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={() => onChange(!checked)}
        className={[
          "relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors focus:outline-none focus:ring-1 focus:ring-gray-400",
          checked ? "bg-gray-600" : "bg-gray-300",
        ].join(" ")}
      >
        <span
          className={[
            "inline-block h-3.5 w-3.5 transform rounded-full bg-white shadow-sm transition-transform",
            checked ? "translate-x-[18px]" : "translate-x-0.5",
          ].join(" ")}
        />
      </button>
    </div>
  );
}
